import React from 'react'

import { columnsFactory } from 'vendor/pages/Private/@v2/Orders/constants/columns_definition'

import { toJS } from 'mobx'
import { observer } from 'mobx-react-lite'

import { PsqlTableProvider } from 'common/components/PsqlTable/psql_table_provider'
import { PersistentFiltersProvider } from 'common/contexts/persistent_filters'

import { useVendorStores } from 'vendor/hooks/use-stores'
import { VendorOrdersPageContent } from 'vendor/pages/Private/@v2/Orders/orders_content'

function Page() {
  const {
    userStore,
    notificationStore,
    orderStore: { listStore },
  } = useVendorStores()

  return (
    <PersistentFiltersProvider
      ignoreOnFilterCounter={['tab', 'only_vendor_user_orders']}
      ignoreQueryParams={['state', 'tab']}
      listStore={listStore}
    >
      <PsqlTableProvider
        tableName="AllOrders"
        options={{
          data: toJS(listStore.records),
          sort: {
            sortFromPersistentFilter: true,
            field: listStore.searchState.sort,
            direction: listStore.searchState.sort_direction,
          },
          columns: columnsFactory({
            statusColumn: {
              getNotificationsCount: (id) => notificationStore.notificationsCountByOrder(id),
            },
            actionsColumn: {
              disabled: !userStore.canUseOrdersDownload,
            },
          }),
        }}
      >
        <VendorOrdersPageContent />
      </PsqlTableProvider>
    </PersistentFiltersProvider>
  )
}

export const VendorOrdersPageV2 = observer(Page)
